import { Navigate, generatePath } from "react-router";

import { PATHS } from "@/routes/paths";

import { useHotelApplicationDataQuery } from "@/components/features/_shared/repository/hotel-application-data/query";

import { useFetchHotelTop } from "../api";
import { IslandAdminMediaArticleList, IslandHotelUrls, IslandStartGuide } from "./island";

type Props = {
	hotelID: string;
};

export const HotelTop = ({ hotelID }: Props) => {
	const { data: hotelTopData } = useFetchHotelTop({ hotelID });
	const { hotelApplicationData } = useHotelApplicationDataQuery(hotelID);

	if (!hotelTopData || !hotelApplicationData) {
		return <Navigate to={generatePath(PATHS.TOP)} />;
	}

	return (
		<main
			// ヘッダーの高さ分だけ下にずらす
			className="mt-14 laptop:mt-0"
		>
			<IslandStartGuide
				startGuide={hotelTopData.startGuide}
				hotelTemplateSettings={hotelTopData.hotelTemplateSettings}
				hotelUrls={hotelTopData.hotelUrls}
				hotelID={hotelID}
				isTestReservationAvailable={hotelApplicationData.hotelApplicationStatus.isTestReservationAvailable}
			/>
			<IslandAdminMediaArticleList hotelID={hotelID} />
			<IslandHotelUrls
				hotelID={hotelID}
				hotelUrls={hotelTopData.hotelUrls}
				inUseBasic={hotelApplicationData.hotelApplicationStatus.inUseBasic}
				isHotelPolicyRegistered={hotelApplicationData.hotelApplicationStatus.isHotelPolicyRegistered}
				isTestReservationAvailable={hotelApplicationData.hotelApplicationStatus.isTestReservationAvailable}
			/>
		</main>
	);
};
